const AUTH_SEED = 'authseed';
const TOKEN = 'token';
const USER = 'user';

class Security { // eslint-disable-line fp/no-class
  unregisterAuthSeed = () => {
    localStorage.removeItem(AUTH_SEED);
  };

  registerAuthseed = (seed) => {
    localStorage.setItem(AUTH_SEED, seed);
  };

  getAuthseed = () => localStorage.getItem(AUTH_SEED);

  registerToken = (token) => {
    localStorage.setItem(TOKEN, token);
  };

  getToken = () => localStorage.getItem(TOKEN);

  registerUser = (user) => {
    localStorage.setItem(USER, user);
  };

  getUser = () => localStorage.getItem(USER);

  registerKey = (user, key) => {
    localStorage.setItem(user.id, key);
  };

  getKey = (user) => localStorage.getItem(user.id);

  hasKey = (user) => this.getKey(user) !== null;

  logout = () => {
    const user = this.getUser();
    localStorage.removeItem(AUTH_SEED);
    localStorage.removeItem(USER);
    localStorage.removeItem(TOKEN);
    if (user) {
      localStorage.removeItem(user.id);
    }
  };

  clear = () => {
    this.logout();
  };
}

export default new Security();
